module.exports = __webpack_public_path__ + "static/media/image.93a57c9f.png";